module.exports = __webpack_public_path__ + "static/media/Icon_PanningTool.53e4c14d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/icons/svg/Icon_PanningTool.svg
// module id = 2321
// module chunks = 0